<template>
  <div class="t-lk-title-link t-lk-container-mobile">
    <h1 class="t-lk-title t-lk-title-link__title">{{ title }}</h1>
    <btn-green-cmp :link="link" :name="name"> </btn-green-cmp>
  </div>
</template>

<script>
import btnGreen from '@components/lk/btn-green/btn-green.vue'

export default {
  name: 'lk-title-link',
  props: ['title', 'link', 'name'],
  components: {
    'btn-green-cmp': btnGreen,
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-title-link/lk-title-link.vue